<template>
  <div class="app-main-content">
    <subscribe-list subscribe-name="PF" />
  </div>
</template>

<script>

import SubscribeList from '@/views/cargo/v0/Price/components/list/subscribeList'

export default {
  name: 'PriceFCLSubscribe',
  components: { SubscribeList }
}
</script>

<style scoped>

</style>
